import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { process } from "@progress/kendo-data-query";

export default class SalesRepDetailComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "dealers",
      dealers: (props.dealers || []).slice(),
      selectedIds: {},
      reassignTarget: null,
      busy: false,
      message: ""
    };
  }

  setTab = (tab) => this.setState({ activeTab: tab, message: "" });

  toggleSelect = (id) => {
    var sel = { ...this.state.selectedIds };
    if (sel[id]) delete sel[id]; else sel[id] = true;
    this.setState({ selectedIds: sel });
  };

  toggleSelectAll = () => {
    var allIds = this.state.dealers.map(d => d.id);
    var allSelected = allIds.every(id => this.state.selectedIds[id]);
    if (allSelected) {
      this.setState({ selectedIds: {} });
    } else {
      var sel = {};
      allIds.forEach(id => { sel[id] = true; });
      this.setState({ selectedIds: sel });
    }
  };

  reassignSelected = async () => {
    var ids = Object.keys(this.state.selectedIds);
    if (ids.length === 0) { this.setState({ message: "Select at least one dealer." }); return; }
    if (!this.state.reassignTarget) { this.setState({ message: "Choose a sales rep to reassign to." }); return; }
    var newRep = this.state.reassignTarget.email;
    if (!confirm("Reassign " + ids.length + " dealer(s) to " + newRep + "?")) return;
    this.setState({ busy: true, message: "" });
    try {
      var res = await fetch("/api/Admin/ReassignDealers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dealerUserIds: ids, newSalesRepEmail: newRep })
      });
      var body = await res.json();
      if (!res.ok) throw new Error(body.message || "Reassign failed");
      var remaining = this.state.dealers.filter(d => !this.state.selectedIds[d.id]);
      this.setState({
        dealers: remaining,
        selectedIds: {},
        reassignTarget: null,
        message: "Reassigned " + body.updated + " dealer(s)" + (body.errors ? " (" + body.errors + " errors)" : ""),
        busy: false
      });
    } catch (e) {
      this.setState({ message: "Error: " + e.message, busy: false });
    }
  };

  renderDealersTab() {
    var dealers = this.state.dealers;
    var selectedCount = Object.keys(this.state.selectedIds).length;
    var allSelected = dealers.length > 0 && dealers.every(d => this.state.selectedIds[d.id]);
    var options = this.props.salesRepOptions || [];
    return (
      <div>
        <div className="quote-history-filters" style={{ alignItems: "flex-end" }}>
          <div className="quote-filter-item" style={{ minWidth: "260px" }}>
            <label>Reassign selected to</label>
            <DropDownList
              data={options}
              textField="name"
              dataItemKey="email"
              value={this.state.reassignTarget}
              onChange={(e) => this.setState({ reassignTarget: e.target.value })}
              defaultItem={{ email: "", name: "Choose a sales rep..." }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="quote-filter-item">
            <button
              className="ui-button ink"
              style={{ background: "#333", color: "#fff" }}
              disabled={selectedCount === 0 || !this.state.reassignTarget || this.state.busy}
              onClick={this.reassignSelected}
            >
              {this.state.busy ? "Working..." : "Apply Reassignment"}
            </button>
          </div>
          <div className="quote-filter-item">
            <span>{selectedCount} selected</span>
          </div>
        </div>
        {this.state.message && (
          <div style={{ padding: "8px 12px", marginBottom: "12px", background: "#f4f4f4", border: "1px solid #ddd", borderRadius: "3px" }}>
            {this.state.message}
          </div>
        )}
        <table className="admin-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "40px" }}>
                <input type="checkbox" checked={allSelected} onChange={this.toggleSelectAll} />
              </th>
              <th>Name</th>
              <th>Email</th>
              <th>Company</th>
              <th>Industry</th>
              <th>Type</th>
              <th>Acct #</th>
              <th>Zip</th>
              <th>Last Activity</th>
            </tr>
          </thead>
          <tbody>
            {dealers.length === 0 && (
              <tr><td colSpan={9} style={{ textAlign: "center", padding: "24px", color: "#666" }}>No dealers assigned to this rep.</td></tr>
            )}
            {dealers.map(d => (
              <tr key={d.id}>
                <td><input type="checkbox" checked={!!this.state.selectedIds[d.id]} onChange={() => this.toggleSelect(d.id)} /></td>
                <td>{d.name}</td>
                <td>{d.email}</td>
                <td>{d.company}</td>
                <td>{d.industryType}</td>
                <td>{d.businessType}</td>
                <td>{d.fairfieldAccountNumber}</td>
                <td>{d.fficZips}</td>
                <td>{d.lastActivityDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderQuotesTab() {
    var quotes = this.props.quotes || [];
    return (
      <table className="admin-table" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Quote #</th>
            <th>Project</th>
            <th>Company</th>
            <th>Date</th>
            <th>Status</th>
            <th style={{ textAlign: "right" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {quotes.length === 0 && (
            <tr><td colSpan={6} style={{ textAlign: "center", padding: "24px", color: "#666" }}>No quote requests for this rep.</td></tr>
          )}
          {quotes.map(q => (
            <tr key={q.id}>
              <td><a href={"/Quote/Detail/" + q.id}>{q.friendlyId}</a></td>
              <td>{q.projectName}</td>
              <td>{q.company}</td>
              <td>{q.dateSubmitted}</td>
              <td><span className={"admin-status " + (q.status || "").toLowerCase()}>{q.status}</span></td>
              <td style={{ textAlign: "right" }}>${(q.total || 0).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  renderRegistrationsTab() {
    var regs = this.props.registrations || [];
    return (
      <table className="admin-table" style={{ width: "100%" }}>
        <thead>
          <tr><th>Company</th><th>Name</th><th>Email</th><th>Date</th><th>Status</th></tr>
        </thead>
        <tbody>
          {regs.length === 0 && (
            <tr><td colSpan={5} style={{ textAlign: "center", padding: "24px", color: "#666" }}>No registrations for this rep.</td></tr>
          )}
          {regs.map(r => (
            <tr key={r.id}>
              <td><a href={"/Registration/Detail/" + r.id}>{r.companyName}</a></td>
              <td>{r.name}</td>
              <td>{r.email}</td>
              <td>{r.dateSubmitted}</td>
              <td><span className={"admin-status " + (r.status || "").toLowerCase()}>{r.status}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    var rep = this.props.rep || {};
    var tab = this.state.activeTab;
    var dealerCount = this.state.dealers.length;
    var quoteCount = (this.props.quotes || []).length;
    var regCount = (this.props.registrations || []).length;
    return (
      <div>
        <div className="admin-section">
          <h3 className="admin-section-title">Profile</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "12px 24px" }}>
            <div><strong>Email:</strong> {rep.email}</div>
            <div><strong>Phone:</strong> {rep.phoneNumber || "—"}</div>
            <div><strong>Company:</strong> {rep.company || "—"}</div>
            <div><strong>Industry:</strong> {rep.industryType || "—"}</div>
            <div><strong>Type:</strong> {rep.businessType || "—"}</div>
            <div><strong>Rep #:</strong> {rep.fficRepnum || "—"}</div>
            <div><strong>Status:</strong> {rep.isApproved ? "Active" : "Disabled"}</div>
            <div><strong>Last Activity:</strong> {rep.lastActivityDate || "—"}</div>
          </div>
        </div>

        <div className="admin-section">
          <div style={{ borderBottom: "1px solid #ddd", marginBottom: "16px" }}>
            <button className={"ui-button" + (tab === "dealers" ? " ink" : "")} onClick={() => this.setTab("dealers")} style={{ marginRight: "8px" }}>
              Dealers ({dealerCount})
            </button>
            <button className={"ui-button" + (tab === "quotes" ? " ink" : "")} onClick={() => this.setTab("quotes")} style={{ marginRight: "8px" }}>
              Quotes ({quoteCount})
            </button>
            <button className={"ui-button" + (tab === "registrations" ? " ink" : "")} onClick={() => this.setTab("registrations")}>
              Registrations ({regCount})
            </button>
          </div>
          {tab === "dealers" && this.renderDealersTab()}
          {tab === "quotes" && this.renderQuotesTab()}
          {tab === "registrations" && this.renderRegistrationsTab()}
        </div>
      </div>
    );
  }
}
